export interface ProductDeal {
  account: string
  deal_id: string
  deal_name: string
  amount: number
  product_type: string
  date_created: string
  date_closed_won: string
  commission_value: number
  deal_stage: string
}

export interface ProductSummary {
  product_type: string
  total_count: number
  total_value: number
  total_commission: number
  percentage_by_count: number
  percentage_by_value: number
}

export interface AccountSummary {
  account: string
  total_deals: number
  total_value: number
  total_commission: number
  product_breakdown: ProductSummary[]
}

export interface DashboardData {
  total_deals: number
  total_value: number
  total_commission: number
  accounts: AccountSummary[]
  product_summary: ProductSummary[]
  deals_by_month: { [key: string]: number }
  value_by_month: { [key: string]: number }
}

export interface ProductFilter {
  account?: string
  product_type?: string
  date_from?: string
  date_to?: string
  search?: string
}

export const CHART_COLORS = [
  '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6',
  '#06b6d4', '#84cc16', '#f97316', '#ec4899', '#6366f1',
  '#14b8a6', '#eab308', '#dc2626', '#9333ea', '#0891b2'
]